import { ACTIONS_TEAM } from "../actions/team-pitchers";
const ACTIONS = {
    GET_INFO_TEAM_1_SUCCESS : 'GET_INFO_TEAM_1_SUCCESS',
    GET_INFO_TEAM_1_ERROR : 'GET_INFO_TEAM_1_ERROR'
}
const headerERATable = ['順位', '選手名', '防御率'];
const titleERATable = {
    dot: false,
    text: '防御率',
};
const mockDataERATable = [
    {
        item: [
            { text: 1 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 2 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 3 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
];

const headerVictoryTable = ['順位', '選手名', '勝利'];
const titleVictoryTable = {
    dot: false,
    text: '勝利',
};
const mockDataVictoryTable = [
    {
        item: [
            { text: 1 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 2 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 3 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
];

const headerStrikeoutTable = ['順位', '選手名', '奪三振'];
const titleStrikeoutTable = {
    dot: false,
    text: '奪三振',
};
const mockDataStrikeoutTable = [
    {
        item: [
            { text: 1 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 2 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 3 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
];

const headerPitchingTable = ['順位', '選手名', '登板'];
const titlePitchingTable = {
    dot: false,
    text: '登板',
};
const mockDataPitchingTable = [
    {
        item: [
            { text: 1 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 2 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 3 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
];

export default (state = {
    headerERATable, titleERATable, mockDataERATable, headerVictoryTable,
    titleVictoryTable, mockDataVictoryTable, headerStrikeoutTable, titleStrikeoutTable,
    mockDataStrikeoutTable, headerPitchingTable, titlePitchingTable, mockDataPitchingTable
}, action) => {
    switch (action.type) {
        case ACTIONS_TEAM.GET_INFO_PITCHERS_GAMES_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data.data,
                default_sort: action.data.default_sort
            };
        case ACTIONS.GET_INFO_TEAM_1_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS.GET_INFO_TEAM_1_ERROR:
        case ACTIONS_TEAM.GET_INFO_PITCHERS_GAMES_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};